export const baseURL = "https://api.doctrue.in/api/v1";
// export const baseURL = "https://dev.api.doctrue.in/api/v1";


// export const baseURL = "http://localhost:8000/api/v1";


export const DT_DEFAULT_UUID = "30368881-79e2-4ff3-9d7d-c376ea1e8f7e";

// export const hospitalWithCustomPaymentSlots = [
//   // "7e32dbc9-4404-4688-b01b-eaa06ef456eb",
//   "952b4310-c1be-4e4c-8795-81c7664566ee",
// ];

// export const videoConsultClinics = [
//   "7e32dbc9-4404-4688-b01b-eaa06ef456eb",
//   "6af66f47-8a62-4999-8b82-50b2d40846ae",
//   "fa577fb4-6353-44ae-9a41-0d362d0ab5ce",
//   "18b848bd-cbce-4016-ab6c-28fe2c229976",
//   "952b4310-c1be-4e4c-8795-81c7664566ee"
// ];

export const weekBookingCheckClinics = [
  // "7e32dbc9-4404-4688-b01b-eaa06ef456eb",
  "ea071a5b-e6c2-4bd1-9ed2-ce44e4505090",
];

// export const prePayment = [
//   "7e32dbc9-4404-4688-b01b-eaa06ef456eb",
//   "6af66f47-8a62-4999-8b82-50b2d40846ae",
//   "afb059d4-938e-493f-a723-3b473899fd2c",
//   "499c4c7b-d288-4685-99f1-9efe77e15086",
//   "b6d4fb96-165c-4fb3-a675-298712568a49",
//   "18b848bd-cbce-4016-ab6c-28fe2c229976",
//   "7c8eb809-8062-42fe-b235-f5e759125bd5",
//   "952b4310-c1be-4e4c-8795-81c7664566ee"
// ];

export const scanQueue = [
  // "7e32dbc9-4404-4688-b01b-eaa06ef456eb",
  "6af66f47-8a62-4999-8b82-50b2d40846ae",
  "ea071a5b-e6c2-4bd1-9ed2-ce44e4505090",
];

export const mentsReception = [
  "5a6155df-6b50-4621-a035-c1953bb0f249",
  "2ceb88d6-5227-4a04-bf7d-ea2f1c78c1f4",
];

export const estimateVisitTime = ["fa577fb4-6353-44ae-9a41-0d362d0ab5ce"];

// export const noExtendSession = [
//   "3635f86c-6baf-4fbc-99b1-b47d555afce0",
//   "afa82b4b-8292-4423-811f-d3bf2226e482",
//   "0492c7f0-39a2-4173-a214-ccd6a756127d",
//   "4f43a787-adaf-46b2-9b34-97976023b22d",
//   "bf9dd367-69ab-43bd-b0b1-ae3805a0fae6",
// ];

// export const noWalkinButton = [
//   "8741013f-d20d-4901-96c2-22a3137ba507",
//   "4675c436-4e6e-46f3-bfae-0964139b0445",
//   "a894e03f-6efd-4668-8887-9647eb3c0832",
//   "d1f75638-5fef-4684-9d49-8df0e9450fb1",
// ];

// export const languageChangeButton = [
//   "7e32dbc9-4404-4688-b01b-eaa06ef456eb",
//   "6af66f47-8a62-4999-8b82-50b2d40846ae",
//   "1536a4b7-5dbc-486f-b095-911de82b130a",
//   "18b848bd-cbce-4016-ab6c-28fe2c229976",
//   "ea071a5b-e6c2-4bd1-9ed2-ce44e4505090",
//   "6e125d1d-7507-4bb2-bc4f-c635a1741c9e",
//   "6de17978-ec3a-4899-aab3-7896c819bbf2"
// ]

// export const languageChangeButtonArabic = [
//   "f6378aa4-0b3c-42e3-be8f-bb8b85f256c0",
// ]

export const hospitalWithSessionToken = [
  "ea071a5b-e6c2-4bd1-9ed2-ce44e4505090",
  "c16ca35b-eb07-44aa-b8e0-a4f2f372c303",
  "f6152250-3ad7-4050-b2d4-d09f9c0e814a",
  "27ad03f9-7ef6-44e3-8ad2-ed665908a380",
  "d1a7aaa3-b333-40cd-bfc9-788c6dcb3d3b",
  "7e32dbc9-4404-4688-b01b-eaa06ef456eb",
  "9f79a818-a00b-4d6c-9283-8970782722b7",
  "32b6d9d0-1588-403e-9799-913b77487e65",
  "7e32dbc9-4404-4688-b01b-eaa06ef456eb",
  "07693ba6-950d-4a71-a31e-71c4e43c65ea"
];

// export const dummyParentBranch = [
//   "35be3fa2-4292-412c-8f52-e3deeff08dd2",
//   "2d38691e-0d40-4388-a6ab-f65c5afc40ae"
// ]

export const sultanHospitals = ["f6378aa4-0b3c-42e3-be8f-bb8b85f256c0"];

export const hospWithSearchableNameField = [
  "35be3fa2-4292-412c-8f52-e3deeff08dd2",
  "a7e63ce9-92b5-415e-a60c-55aefc93e842",
  "a1cd1fd7-9144-42ef-a3ad-770afbd4b7bc",
  // "7e32dbc9-4404-4688-b01b-eaa06ef456eb"
];
export const hospitalWithBillNoFeature = [
  // "7e32dbc9-4404-4688-b01b-eaa06ef456eb"
  "ea071a5b-e6c2-4bd1-9ed2-ce44e4505090",
];

export const hospitalWithTriggerBot = [
  // "7e32dbc9-4404-4688-b01b-eaa06ef456eb"
  "5d4aa83f-2137-4d3f-99c8-e4fb8baad30d",
  "e22f2a20-bbda-4aeb-83f6-d562bae0d427",
  "39c9ffb8-4dc5-4916-b451-c00d168ebd03",
  "0a51426e-bf07-4562-8086-f99b969543c0",
  "098d709e-3282-4885-beea-28a9934c6f3c",
  "a57b79a0-65be-46ab-9072-33946c8c737b",
  "7edf9854-9327-4220-8268-96e512c364a1",
  "03ca41df-74ae-48d3-a7dc-8a7d5dd5cb7b",
];

export const hospitalWithCheckInLock = [
  // "7e32dbc9-4404-4688-b01b-eaa06ef456eb"
  // "18b848bd-cbce-4016-ab6c-28fe2c229976",
  "6de17978-ec3a-4899-aab3-7896c819bbf2",
  "5d4aa83f-2137-4d3f-99c8-e4fb8baad30d",
  "b366e525-c9ab-490f-9959-4f1318912e48",
];

export const cutisHospitalId = "b366e525-c9ab-490f-9959-4f1318912e48";
export const shanthigynecID = "d1a7aaa3-b333-40cd-bfc9-788c6dcb3d3b" ;
export const akshareyeclinicID = "1cb4c6fe-c7d2-4686-8afe-8c7c626e8e21";
export const devTestingHospitalID = "7e32dbc9-4404-4688-b01b-eaa06ef456eb";

// Hospitals that use the full Cutis-style flow:
// custom hourly token block (10 tokens/hour), walk-in slot picker,
// and allowing multiple simultaneous ongoing patients.
export const hospitalsWithHourlyTokenBlock = [
  cutisHospitalId,
  akshareyeclinicID,
  devTestingHospitalID,
  shanthigynecID,
];

export const gunasheelaHidingDetails = ["7b2fecf7-18a2-4fef-ab10-647cc8bc303c"];
